"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AloraPlus = void 0;
const helper_1 = require("../../helper");
const EmrConstants_1 = require("../../EmrConstants");
class AloraPlus {
    parse(pastedData, event, callbackEmit) {
        pastedData = pastedData.replace("\r\n", "\n");
        try {
            console.log("Calling parser : Alora");
            const mobilePhoneMatch = pastedData.match(/Mobile Phone: *([^\n]*)/);
            const mobilePhone = mobilePhoneMatch ? mobilePhoneMatch[1].trim() : "";
            const patientDetails = (0, helper_1.substrInBetweenNew)(pastedData, "Admission Profile\nfor\n", "\n" + EmrConstants_1.PARSER_INPUT_TYPE.LANGUAGE);
            const patientInfo = this.gettingPatientDetails(patientDetails, mobilePhone);
            const insurance = this.getInsurance(pastedData);
            const physicianDetails = (0, helper_1.substrInBetweenNew)(pastedData, "\nPhysician\n", "\nOther Physicians");
            const pharmacyDetails = (0, helper_1.substrInBetweenNew)(pastedData, EmrConstants_1.PARSER_INPUT_TYPE.PHARMACY_MAIN, EmrConstants_1.PARSER_INPUT_TYPE.DME);
            const physicianInfo = this.getPrimaryPhysician(physicianDetails, pharmacyDetails);
            physicianInfo.info.careGiver = this.getCareGiver(pastedData);
            const sendCallBackData = Object.assign(Object.assign(Object.assign({}, patientInfo), insurance), physicianInfo);
            callbackEmit({ parseData: sendCallBackData });
        }
        catch (error) {
            callbackEmit({
                parseData: {},
                isDataParsed: 0,
                errorMessage: error ? error === null || error === void 0 ? void 0 : error.message : error,
                errorStack: error === null || error === void 0 ? void 0 : error.stack,
            });
        }
    }
    gettingPatientDetails(patientDetails, mobilePhone) {
        if (!patientDetails) {
            return {};
        }
        patientDetails = patientDetails.substr(0, patientDetails.indexOf(EmrConstants_1.PARSER_INPUT_TYPE.DISCHARGE_DATE));
        let dateOfBirth = patientDetails.split("\n")
            ? patientDetails.split("\n")[3]
            : null;
        if (dateOfBirth) {
            dateOfBirth = (0, helper_1.trim)(dateOfBirth);
        }
        return {
            patientInfo: Object.assign(Object.assign(Object.assign({}, this.patientName(patientDetails)), this.patientPhoneNumberWithAddress(patientDetails, mobilePhone)), { dob: dateOfBirth && (0, helper_1.getDOB)(dateOfBirth, true) }),
        };
    }
    getPrimaryPhysician(physicianDetails, pharmacyDetails) {
        const primaryPhy = {
            info: {
                physician: [
                    {
                        name: "",
                        phoneNo: "",
                        countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                        sortOrder: 1,
                    },
                ],
                pharmacy: pharmacyDetails ? [this.getPharmacy(pharmacyDetails)] : [],
                careGiver: [],
            },
        };
        const phyInfo = physicianDetails.split("\n");
        primaryPhy.info.physician[0].name = phyInfo[0]
            ? phyInfo[0].replace(/,/g, "").trim()
            : "";
        if (phyInfo[3]) {
            phyInfo[3] = phyInfo[3].replace("(", "");
            phyInfo[3] = phyInfo[3].replace(")", "");
            phyInfo[3] = phyInfo[3].replace(" ", "-");
        }
        primaryPhy.info.physician[0].phoneNo = phyInfo[3] ? phyInfo[3].trim() : "";
        return primaryPhy;
    }
    getPharmacy(data) {
        const pharmacyData = {
            name: "",
            phoneNo: "",
            countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
            sortOrder: 1,
        };
        pharmacyData.name = data.replace(":", "");
        return pharmacyData;
    }
    getInsurance(pastedData) {
        const match = pastedData.match(/Payer & Member ID:\s*(\w+)/);
        return { insurance: match ? match[1] : "" };
    }
    getCareGiver(pastedData) {
        const match = pastedData.match(/Emergency Contact\nName:\s*(.*?)\s*Phone:\s*([\d\s()-]*)/);
        if (!match || !match[1].trim()) {
            return [];
        }
        const phone = match[2].trim().replace(/[\s()-]/g, "");
        return [
            {
                countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                name: match[1].trim(),
                phoneNo: phone ? (0, helper_1.changeNumberUSFormat)(phone) : "",
                sortOrder: 1,
            },
        ];
    }
    patientPhoneNumberWithAddress(firstSession, mobilePhone) {
        const allData = firstSession.split("\n");
        let address = `${firstSession.split("\n")[2]} ${allData[allData.length - 2]}`;
        const info = {
            phoneNo: "",
            address: {
                placeName: "",
                apartmentNo: "",
            },
        };
        if (address) {
            address = address.replace(/[\n]/g, " ");
            info.address.placeName = address;
        }
        if (mobilePhone) {
            const digits = (0, helper_1.trim)(mobilePhone).replace(/[\s-()]/g, "");
            info.phoneNo = (0, helper_1.changeNumberUSFormat)(digits);
        }
        return info;
    }
    patientName(patientDetails) {
        const nameOfPatient = patientDetails.split("\n")[1];
        const parts = nameOfPatient.split(", ");
        return {
            firstName: parts[1] ? parts[1].trim() : "",
            lastName: parts[0] ? parts[0].trim() : "",
        };
    }
}
exports.AloraPlus = AloraPlus;
